import React from 'react';
import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="google-site-verification" content="SS_dmvkkvjW0m4Hxa2yhun9iAfeLG-p9sk_PwN82FZw" />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Vorpoint | Webdesign, Apps & KI-Lösungen für Kleinunternehmen',
  description: 'Digitale Lösungen, die Ihr Business stärken. Vorpoint bietet professionelle Websites, Apps, KI-Integration und Prozessautomatisierung für kleine und mittelständische Unternehmen.',
  keywords: 'Webdesign Leipzig, App Entwicklung, Prozessautomatisierung, KI für Mittelstand, Digitalisierung Kleinunternehmen, Vorpoint, IT-Consulting, E-Commerce Lösungen',
};

export default Meta;